export default __webpack_public_path__ + "static/media/in.249b88f7.svg";